import DataTableHeader from './DataTableHeader';
import DataTableBody from './DataTableBody';
import { Table } from '@/components/ui';
import { useUsers } from '../../hooks';
import Loader from '@/components/custom/Loader';

export const DataTable = () => {
  const { isFetching } = useUsers();

  if (isFetching) {
    return <Loader />;
  }

  return (
    <div className='border rounded-md animate__animated animate__fadeIn'>
      <Table>
        <DataTableHeader />
        <DataTableBody />
      </Table>
    </div>
  );
};

export default DataTable;
